<div [class]="headerCssClass">{{title}}</div>
<div mat-dialog-content>
  <div class="size-full flex flex-col gap-y-2">
    @for (message of messages; track message.id) {
      <div class="font-medium text-base text-carbon last:font-normal last:text-gray-700" [innerHTML]="message.value"></div>
    }
  </div>
  <form class="prompt-form"
      [formGroup]="promptForm"
      (submit)="handleSubmit()">
    <button class="hidden-submit"
            type="submit"
            [mat-dialog-close]="data"
            (click)="handleSubmit()">
    </button>
    @for (field of data.fields; track field.name;) {
      <mat-form-field class="prompt-form-field">
        <input type="text"
            autocomplete="off"
            matInput
            #inputField
            [required]="required"
            [id]="getInputId(field.name)"
            [attr.maxlength]="maxLength"
            [formControlName]="field.name"
            [placeholder]="field.name"
            (blur)="handleBlur(field)"
            (input)="handleInput(field)">
        @if (hintLabel) {
          <mat-hint align="end">{{hintLabel }}</mat-hint>
        }
      </mat-form-field>
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mirButton stroked (click)="handleNoClick()">
    <MirIcon>cancel</MirIcon>
    {{'UI.Cancel' | translate}}
  </button>

    @switch (type) {
      @case ('primary') {
        <button mirButton stroked primary mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
      @case ('accent') {
        <button mirButton stroked accent mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
      @case ('warn') {
        <button mirButton stroked warn mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
      @case ('danger') {
        <button mirButton stroked warn mat-dialog-close
            class="!text-orange-700 hover:!bg-orange-50 hover:!text-orange-700"
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
      @case ('slate') {
        <button mirButton stroked slate mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
      @default {
        <button mirButton stroked mat-dialog-close
            [disabled]="!this.promptForm.valid"
            (click)="handleSubmit()">
          <MirIcon>check</MirIcon>
          {{'UI.OK' | translate}}
        </button>
      }
    }
</div>
